module.exports = __webpack_public_path__ + "img/97.0e49fdf3.jpg";